import axios from "axios";
import endPoints from "../../../../../config/endPoints";


export const getAllProvincesApi = async() => {
  return axios.get(`${endPoints.provinces}`);
};

export const searchProvincesApi = async(string) => {
  return axios.post(`${endPoints.provinces}/search`, string);
};

export const getProvincesInRegionApi = async(regionId) => {
  return axios.get(`${endPoints.provinces}/${regionId}`);
};

